export default __webpack_public_path__ + "static/media/clipboard_sagyouin_man.5a2cef5a.png";